import WithdrawPointImage from '../../assets/images/withdraw-point.png';

export function WithdrawPointIcon(props: any) {
  return <img src={WithdrawPointImage} alt="Event icon" {...props} />;
}
